<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12" v-if="infoObj.gl_ref_number">
                <div class="d-flex headerOrderDetail">
                    <div class="orderNumber">
                        <h1 class="mt-20 pl-20">{{infoObj.gl_ref_number}}</h1>
                        <h4 class="c-orange mb-0 caseStatus text-uppercase">{{infoObj.posting_status}}</h4>
                    </div>
                </div>
            </b-col>
            <b-col md="12" >
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <!-- <gofix-button
                                class="mr-3"
                                :outline="this.$route.params.id != '0' && infoObj.posting_status !== 'Posted'"
                                @click="save(3)"
                                label="Posted"
                                :disabled="this.$route.params.id == '0' || infoObj.posting_status === 'Posted'"></gofix-button> -->
                        <gofix-button
                            class="mr-3"
                            :outline="this.$route.params.id != '0'"
                            @click="modals.cancel.open = true"
                            label="Cancel"
                            :disabled="this.$route.params.id == '0' || infoObj.posting_status != 'Pending' || (infoObj.source_application_info && infoObj.source_application_info.reference_value_text == 'GOfix LM')" />
                        <gofix-button
                            v-if="infoObj.posting_status != 'Blocked'"
                            class="mr-3"
                            :outline="this.$route.params.id != '0'"
                            @click="save(1)"
                            label="Block"
                            :disabled="!$checkRole($accessModule.general_ledger, 'update') || (this.$route.params.id == '0' || infoObj.posting_status != 'Pending')" />
                        <gofix-button
                            v-if="infoObj.posting_status == 'Blocked'"
                            class="mr-3"
                            :outline="this.$route.params.id != '0'"
                            @click="save(4)"
                            label="UnBlock"
                            :disabled="!$checkRole($accessModule.general_ledger, 'update')" />
                        <gofix-button 
                            @click="save(0)" 
                            label="Save"
                            :disabled="(this.$route.params.id != '0' && infoObj.posting_status == 'Cancelled') || infoObj.posting_status == 'Posted' || infoObj.posting_status == 'Exported' || (infoObj.source_application_info && infoObj.source_application_info.reference_value_text == 'GOfix LM')" />
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                                v-model="infoObj.transaction_date"
                                                label="Transaction Date" disabled>
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Transaction Code"
                                                v-model="infoObj.transaction_code"
                                                :options="optionsTransaction"
                                                vLabel="txn_code">
                                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                <div class="flex">
                                                    <div class="">
                                                        <span>{{ (option.txn_code && option.txn_description) ? option.txn_code + " " +option.txn_description : option.txn_code ? option.txn_code + ' -' : option.txn_description ? option.txn_description : '-' }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                            <template #gofixInput:dropdown:option="option">
                                                {{ (option.txn_code && option.txn_description) ? option.txn_code + " " +option.txn_description : option.txn_code ? option.txn_code + ' -' : option.txn_description ? option.txn_description : '-' }}
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input
                                                label="Batch No"
                                                v-model="infoObj.posting_batch_no"
                                                autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                                v-model="infoObj.export_datetime"
                                                label="Export Date" disabled>
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                                v-model="infoObj.posting_datetime"
                                                label="Posting Date" :disabled="true">
                                        </gofix-form-input-date>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input
                                                label="Document Ref"
                                                v-model="infoObj.document_reference"
                                                autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                                v-model="infoObj.document_date"
                                                label="Document Date" :disabled="true">
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-form-input
                                                label="Description"
                                                v-model="infoObj.description"
                                                autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Finance Company"
                                                :options="optionsCompanies"
                                                vLabel="name"
                                                v-model="infoObj.coa_company">
                                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                <div class="flex">
                                                    <div class="">
                                                        <span>{{ (option.name && option.code) ? option.name + " - " + option.code : option.name }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                            <template #gofixInput:dropdown:option="option">
                                                {{ (option.name && option.code) ? option.name + " - " + option.code : option.name }}
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-supplier
                                                label="Customer/Supplier Comapny"
                                                :contract-id="infoLineItem.contract ? infoLineItem.contract.id : null"
                                                v-model="infoObj.customer_supplier">
                                        </gofix-form-supplier>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input
                                                label="Navision Ref No"
                                                v-model="infoObj.navision_ref_no"
                                                autocomplete="off" disabled>
                                        </gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input
                                                label="Bank Code"
                                                v-model="infoObj.debtor_creditor_bank_code"
                                                autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input
                                                label="Currency"
                                                v-model="infoObj.currency"
                                                autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                                label="Payment Code"
                                                v-model="infoObj.payment_mode"
                                                :options="optionsPayment"
                                                :reduce="option => option.reference_value_text"
                                                vLabel="reference_value_text">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input
                                                label="Payment mode offset GL code"
                                                v-model="infoObj.payment_mode_offset_gl_code"
                                                autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mb-2" title="Line Items" fullContent v-if='$route.params.id != "0"'>
                                <gofix-table class="noFullHeight scrollAbsolute"
                                    :settings="lineItem.tableConfig"
                                    :table-items="lineItem.tableItems"
                                    @load-items="getTableData"
                                    @delete-items="deleteItems"
                                    @new-item="openLineItems"
                                    @row-click="openEditItems"
                                    ref="gofixTable">
                                    <template slot="gofix_table:total" slot-scope="data">
                                        {{data.item ? $accounting.formatMoney(convertNumberPos(data.item.line_item_amount + data.item.line_item_tax_amount), { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                                    </template>
                                    <template slot="gofix_table:line_item_amount" slot-scope="data">
                                        {{ data.item.line_item_amount ? $accounting.formatMoney(convertNumberPos(data.item.line_item_amount), { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                                    </template>
                                    <template slot="gofix_table:line_item_tax_amount" slot-scope="data">
                                        {{ data.item.line_item_tax_amount ? $accounting.formatMoney(convertNumberPos(data.item.line_item_tax_amount), { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                                    </template>
                                </gofix-table>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modalGeneralLedgerDetail"
                :title="modals.lineItem.title"
                hide-footer :centered="true"
                v-model="modals.lineItem.open"
                @close="closeModal"
                ref="modal-line">
            <div >
                <b-form class="pb-10">
                    <b-row class="">
                        <b-col md="6" class="border-right-ledger">
                            <gofix-form-dropdown
                                label="Client contract"
                                :options="optionsContract"
                                @search="searchContract"
                                :filterable="false"
                                vLabel="contract_name"
                                v-model="infoLineItem.contract">
                            </gofix-form-dropdown>

                            <gofix-form-properties
                                label="Property"
                                :contract-id="(infoLineItem && infoLineItem.contract_id) ? infoLineItem.contract_id : null"
                                valueFormat="object"
                                v-model="infoLineItem.property">
                            </gofix-form-properties>

                            <gofix-form-dropdown
                                label="Dept. Code"
                                vLabel="dept_code"
                                v-model="infoLineItem.dept_code"
                                :options="optionsDepartment.options"
                                @search="searchDepartmentCode"
                                :filterable="false">
                                <template #gofixInput:dropdown:option="option">
                                    {{ option.dept_code ? option.dept_code : '--' }}
                                </template>
                            </gofix-form-dropdown>
                            <gofix-form-input
                                label="GOfix Document Ref. No"
                                v-model="infoLineItem.gofix_document_ref_no"
                                autocomplete="off">
                            </gofix-form-input>
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-input
                                        label="GOfix Doc. Ref. Line No"
                                        v-model="infoLineItem.gofix_document_ref_line_no"
                                        autocomplete="off">
                                    </gofix-form-input>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input
                                        label="Doc. Line No"
                                        v-model="infoLineItem.document_line_no"
                                        autocomplete="off">
                                    </gofix-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input
                                label="Item Code"
                                v-model="infoLineItem.item_code"
                                autocomplete="off">
                            </gofix-form-input>
                            <gofix-form-input
                                label="Item Description"
                                v-model="infoLineItem.line_item_description"
                                autocomplete="off">
                            </gofix-form-input>
                            <gofix-form-input
                                label="Line Item Remark"
                                v-model="infoLineItem.line_item_remark"
                                autocomplete="off">
                            </gofix-form-input>
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-dropdown
                                        label="GL Code"
                                        vLabel="gl_code"
                                        v-model="infoLineItem.line_item_gl_code"
                                        :reduce="option => option.gl_code"
                                        :options="optionsGLCode.options"
                                        @search="searchCOA"
                                        :filterable="false"
                                        required
                                        class="max-height">
                                        <template #gofixInput:dropdown:option="option">
                                            {{ option.gl_code + " " + option.name }}
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input-number
                                        allowNegative
                                        label="Amount"
                                        v-model="infoLineItem.line_item_amount" prefix="$">
                                    </gofix-form-input-number>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-dropdown
                                        label="Tax Code"
                                        v-model="infoLineItem.tax"
                                        :options="optionsTax"
                                        vLabel="description"
                                        :filterable="false"
                                        @search="searchTaxCode">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input-number
                                        allowNegative
                                        label="Tax Amount"
                                        v-model="infoLineItem.line_item_tax_amount" prefix="$">
                                    </gofix-form-input-number>
                                </b-col>
                            </b-row>
                            <b-row class="padding-top-12">
                                <b-col md="4" class="">
                                    <label class="float-unset display-inline-block general-lable-total">Total Amount</label>
                                </b-col>
                                <b-col md="8">
                                    <div class="info-right general-money">{{ 
                                        $accounting.formatMoney(
                                            (infoLineItem.line_item_amount != null ? $accounting.unformat(infoLineItem.line_item_amount) : 0) + 
                                            (infoLineItem.line_item_tax_amount != null ? $accounting.unformat(infoLineItem.line_item_tax_amount) : 0), 
                                            { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }
                                        ) 
                                    }}</div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" :disabled="infoObj.posting_status === 'Posted' || infoObj.posting_status === 'Exported'" @click="saveLineItems"  noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.cancel.open">
            <div class="center">Once cancelled, the entries cannot be<br/>un-cancelled.<br/>Are you sure you want to <strong>proceed</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.cancel.open = false">No</b-button>
                <b-button class="custom-btn" @click="save(2)" :disabled="modals.cancel.loading">
                    <b-spinner v-if="modals.cancel.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';
    const accounting = require('accounting');
    export default {
        name: 'misc-expenses-detail',
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['general_ledger_item']));
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                lineItem:{
                    tableConfig:{
                        name: 'ap-invoice-line-item',
                        controls:{
                            create: true,
                            delete: true,
                        },
                        filter: filter,
                        page: 1,
                        limit: 100,
                        total: 0,
                        useDatabaseView: true,
                        sortColumn: "id",
                        sortDirection: "desc",
                        fields: [
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-center',
                                tdClass: 'checkbox-column text-center',
                                width: 50,
                                thStyle: "width:50px",
                            },
                            {
                                key: 'id',
                                label: '#',
                                isActive: 1,
                                isFilter: false,
                                with:80,
                                thStyle: "width:80px",
                                sorting: true,
                            },
                            {
                                key: 'contract_name',
                                label: 'Client Contract',
                                thStyle: "width:165px",
                                isActive: 1,
                                isFilter: true,
                                with:165,
                                sorting: true,
                            },
                            {
                                key: 'name',
                                label: 'Property',
                                isActive: 1,
                                isFilter: true,
                                with:95,
                                thStyle: "width:95px",
                                sorting: true,
                            },
                            {
                                key: 'dim_1',
                                label: 'Dept. Code',
                                isActive: 1,
                                isFilter: true,
                                with:140,
                                thStyle: "width:140px",
                                sorting: true,
                            },
                            {
                                key: 'gofix_document_ref_no',
                                label: 'GOfix Document Ref No',
                                thClass: 'th-auto',
                                isActive: 1,
                                isFilter: true,
                                with:200,
                                thStyle: "width:200px",
                                sorting: true,
                            },
                            {
                                key: 'gofix_document_ref_line_no',
                                label: 'GOfix Document Ref Line No',
                                isActive: 1,
                                isFilter: true,
                                with:290,
                                thStyle: "width:290px",
                                sorting: true,
                            },
                            {
                                key: 'document_line_no',
                                label: 'Document Line No',
                                isActive: 1,
                                isFilter: true,
                                with:150,
                                thStyle: "width:150px",
                                sorting: true,
                            },
                            {
                                key: 'item_code',
                                label: 'Item Code',
                                isActive: 1,
                                isFilter: true,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            },
                            {
                                key: 'line_item_description',
                                label: 'Item Code Description',
                                isActive: 1,
                                isFilter: true,
                                with:200,
                                thStyle: "width:200px",
                                sorting: true,
                            },
                            {
                                key: 'line_item_gl_code',
                                label: 'GL Code',
                                isActive: 1,
                                isFilter: true,
                                with:140,
                                thStyle: "width:140px",
                                sorting: true,
                            },
                            {
                                key: 'line_item_amount',
                                label: 'Amount',
                                isActive: 1,
                                isFilter: true,
                                with:110,
                                thStyle: "width:110px",
                                sorting: true,
                                thClass: "text-right",
                                tdClass: "text-right"
                            },
                            {
                                key: 'line_item_tax_amount',
                                label: 'Tax Amount',
                                isActive: 1,
                                isFilter: true,
                                with:150,
                                thStyle: "width:150px",
                                sorting: true,
                                thClass: "text-right",
                                tdClass: "text-right"
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                isActive: 1,
                                isFilter: false,
                                with:150,
                                thStyle: "width:150px",
                                sorting: false,
                                thClass: "text-right",
                                tdClass: "text-right"
                            }
                        ]
                    },
                    tableItems: [],
                },
                treeProperty: [],
                optionsTransaction: [],
                optionsCompanies:   [],
                optionsDepartment:  {
                    options: [],
                    timer: null
                },
                optionsPayment:     [],
                optionsContract:    [],
                optionsSupplier:    [],
                optionsTax:         [],
                optionsGLCode:      {
                    options: [],
                    timer: null
                },
                infoObj: {
                    gl_ref_number:    null,
                    posting_status:   'Pending',
                    transaction_date: null,
                    transaction_code: null,
                    posting_batch_no: null,
                    export_datetime:  null,
                    posting_datetime: null,
                    document_reference: null,
                    document_date:    null,
                    description:      null,
                    coa_company:      null,
                    customer_supplier:null,
                    navision_ref_no:  null,
                    currency:         'SGD',
                    debtor_creditor_bank_code:null,
                    payment_mode:     null,
                    payment_mode_offset_gl_code:null,
                },
                infoLineItem: {
                    id:                     null,
                    contract:               null,
                    property:               null,
                    dept_code:              null,
                    document_line_no:       null,
                    gofix_document_ref_no:  null,
                    gofix_document_ref_line_no: null,
                    item_code:              null,
                    line_item_description:  null,
                    line_item_remark:       null,
                    line_item_gl_code:      null,
                    line_item_tax_code:     null,
                    tax:                    null,
                    line_item_amount:       null,
                    line_item_tax_amount:   null
                },
                tierLevel: 1,
                isRemove: false,
                selected: [],
                loading:{
                    properties:false,
                    employee  :false,
                    supplier  :false,
                    fmcode    :false,
                    department: false
                },
                modals:{
                    lineItem:{
                        open:false,
                        loading:false,
                        title:"Add Line Item",
                    },
                    cancel: {
                        open: false,
                        loading:false,
                    }
                },
            }
        },
        created () {
            this.infoLineItem.contract = (this.ClientContractID && this.ClientContractID.hasOwnProperty('id')) ? this.ClientContractID : null
            this.getFinanceCompanies()
            this.getPayment();
            this.getContract();
            this.loadTax();
            this.getTransactionCode();
            if(this.$route.params.id != "0"){
                this.getGeneralLedgerInfo()
            } else {
                this.infoObj.transaction_date = new Date()
                this.infoObj.export_datetime  = new Date()
                this.infoObj.posting_datetime = new Date()
                this.infoObj.document_date    = new Date()
            }
        },
        watch: {
           "infoLineItem.contract": function(val, old){
                if(val && val.id) {
                    let arrContact = this.optionsContract.filter(item => item.id == val.id);
                    if(arrContact.length)  this.infoLineItem.contract_id = val.id

                    this.loadRootProperty();
                    this.getDepartmentCode();
                    this.loadCOA();
                } else{
                    this.infoLineItem.contract_id = null;
                    this.optionsGLCode.options = [];
                    this.optionsDepartment.options = [];
                }
            },
            ClientContractID: function(val, old){
                if(old && val && old.id != val.id) {
                    this.infoLineItem.contract = val;
                    this.infoLineItem.contract_id = val.id
                }

                if(!old && val) {
                    this.infoLineItem.contract = val;
                }
            },
            "infoLineItem.property": function(val, old){
                if(val && val.id) {
                    this.getDepartmentCode();
                }
            },
            "infoLineItem.line_item_amount": function(val, old){
                if(val) {
                    if((old != null && old.includes('$') && val.includes('$') || (old == null && !this.infoLineItem.id) || (!old && !this.infoLineItem.id)) && this.infoLineItem.tax) {
                        this.infoLineItem.line_item_tax_amount = this.$accounting.formatMoney( Math.abs((this.infoLineItem.tax.rate) * accounting.unformat(val)) )
                    }
                }
            },
            "infoLineItem.tax": function(val, old){
                if(!val) this.infoLineItem.line_item_tax_amount = null;
                if(val && (val.rate != null || val.rate != undefined)) {
                    if(
                        (
                            old != null 
                            || (old == null && !this.infoLineItem.id) 
                            || (
                                old == null 
                                && this.infoLineItem.id 
                                && !this.infoLineItem.line_item_tax_amount 
                            )
                        ) 
                        && this.infoLineItem.line_item_amount 
                        && accounting.unformat(this.infoLineItem.line_item_amount) != 0
                    ) {
                        this.infoLineItem.line_item_tax_amount = this.$accounting.formatMoney( Math.abs((val.rate) * accounting.unformat(this.infoLineItem.line_item_amount)) )
                    }
                }
            },
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        methods:{
            convertNumberPos(number) {
                //if(number < 0) return number * (-1);
                return number;
            },
            /*save*/
            save(status = 0){
                let request = {
                    transaction_date:               this.infoObj.transaction_date ? moment(new Date(this.infoObj.transaction_date)).format("YYYY-MM-DD") : null,
                    transaction_code_id:            this.infoObj.transaction_code ? this.infoObj.transaction_code.txn_code : null,
                    txn_description:                this.infoObj.transaction_code ? this.infoObj.transaction_code.txn_description : null,
                    txn_account_type:               this.infoObj.transaction_code ? this.infoObj.transaction_code.txn_account_type : null,
                    posting_batch_no:               this.infoObj.posting_batch_no,
                    export_datetime:                this.infoObj.export_datetime ? moment(new Date(this.infoObj.export_datetime)).format("YYYY-MM-DD") : null,
                    posting_datetime:               this.infoObj.posting_datetime ? moment(new Date(this.infoObj.posting_datetime)).format("YYYY-MM-DD") : null,
                    document_reference:             this.infoObj.document_reference,
                    document_date:                  this.infoObj.document_date ? moment(new Date(this.infoObj.document_date)).format("YYYY-MM-DD") : null,
                    description:                    this.infoObj.description,
                    coa_company_id:                 this.infoObj.coa_company ? this.infoObj.coa_company.id : null,
                    customer_supplier_id:           this.infoObj.customer_supplier ? this.infoObj.customer_supplier.id : null,
                    debtor_creditor_code:           this.infoObj.customer_supplier ? this.infoObj.customer_supplier.creditor_code : null,
                    customer_supplier_code:         this.infoObj.customer_supplier ? this.infoObj.customer_supplier.vendor_code : null,
                    customer_supplier_name:         this.infoObj.customer_supplier ? this.infoObj.customer_supplier.name : null,
                    navision_ref_no:                this.infoObj.navision_ref_no,
                    currency:                       'SGD',
                    payment_mode:                   this.infoObj.payment_mode,
                    payment_mode_offset_gl_code:    this.infoObj.payment_mode_offset_gl_code,
                    posting_status:                 this.infoObj.posting_status,
                    debtor_creditor_bank_code:      this.infoObj.debtor_creditor_bank_code,
                };
                if(status === 1){
                    request.posting_status = 'Blocked'
                }
                if(status === 2){
                    request.posting_status = 'Cancelled'
                }
                if(status === 3){
                    request.posting_status = 'Posted'
                }
                if(status === 4){
                    request.posting_status = 'Pending'
                }
                let method    = 'createItem';
                let keyMessage= 'adding'
                if(this.$route.params.id != "0") {
                    request.id = this.$route.params.id
                    method     = 'updateItem';
                    keyMessage = 'editing'
                } else {
                    request.line_items = []
                }
                this.$store.dispatch(`GeneralLedgerController/${method}`, request)
                .then(async (response) => {
                    this.modals.cancel.loading = false
                    this.modals.cancel.open = false
                    this.infoObj.posting_status =  response.data.data.posting_status
                    this.$bvToast.toast( this.$notificationV2(keyMessage, 'gl_manual'), {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    });
                    if(this.$route.params.id == "0"){
                        await this.$router.push('/v2/general-ledger/' + response.data.data.id)
                        await this.getGeneralLedgerInfo()
                    } 
                })
            },

            /*==========================*/
            /* get info*/
            getGeneralLedgerInfo()
            {
              this.$store.dispatch('GeneralLedgerController/getItem', {id: this.$route.params.id})
                .then(response => {
                  this.infoObj = response.data.data;
                  this.infoObj.transaction_date = this.infoObj.transaction_date ? new Date(moment(this.infoObj.transaction_date,"YYYY-MM-DD").toISOString()) : null;
                  this.infoObj.export_datetime = this.infoObj.export_datetime ? new Date(moment(this.infoObj.export_datetime,"YYYY-MM-DD").toISOString()) : null;
                  this.infoObj.posting_datetime = this.infoObj.posting_datetime ? new Date(moment(this.infoObj.posting_datetime,"YYYY-MM-DD").toISOString()) : null;
                  this.infoObj.document_date = this.infoObj.document_date ? new Date(moment(this.infoObj.document_date,"YYYY-MM-DD").toISOString()) : null;
                  if(!this.infoObj.customer_supplier && this.infoObj.customer_supplier_name) {
                    this.infoObj.customer_supplier = {
                        id: null,
                        creditor_code: null,
                        vendor_code: this.infoObj.customer_supplier_code,
                        name: this.infoObj.customer_supplier_name,
                    }
                  }
                })
                .catch(err => {
                    this.$bvToast.toast("Can not load the GENERAL LEDGER INFO", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                })
            },

            /*----- Get data ----------------------------------------------*/
            async getTableData(callback){
                if(this.$route.params.id == "0"){
                    this.lineItem.tableItems = [];
                    this.lineItem.tableConfig.total = 0;
                } else {
                    
                }
                const { tableRequest , resolve,reject } = await callback();
                if(this.$route.params.id == "0"){
                    tableRequest.filter.header_id.value = -1;
                } else {
                    tableRequest.filter.header_id.value = this.$route.params.id;
                }
                await this.$store.dispatch("GeneralLedgerController/getGLLineItems", tableRequest)
                .then(response => {
                    this.lineItem.tableItems = response.items;
                    this.lineItem.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$bvToast.toast("Can not load the items", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                    reject();
                })
            },

            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('GeneralLedgerController/deleteGLLineItems', {ids: ids, header_id: this.$route.params.id})
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'line_item'))
                    })
                    .catch(err => {
                        reject();
                    })
            },

            openLineItems(){
                if(this.$route.params.id == "0"){
                    return this.$bvToast.toast('Please submit a new "General Ledger"', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                if(this.infoObj.posting_status === 'Posted' || this.infoObj.posting_status === 'Exported'){
                    return this.$bvToast.toast('The "General Ledger" is ' + this.infoObj.posting_status + '. So you can not add a line item', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                this.modals.lineItem.title = "Add Line Item"
                this.modals.lineItem.open = true;
                if(this.ClientContractID) {
                    this.infoLineItem.contract = this.ClientContractID
                    this.infoLineItem.contract_id = this.ClientContractID.id
                }
            },

            closeModal() {
                this.infoLineItem = Object.assign(this.infoLineItem,{
                    id:                     null,
                    contract:               null,
                    property:               null,
                    dept_code:              null,
                    document_line_no:       null,
                    gofix_document_ref_no:  null,
                    gofix_document_ref_line_no: null,
                    item_code:              null,
                    line_item_description:  null,
                    line_item_remark:       null,
                    line_item_gl_code:      null,
                    line_item_tax_code:     null,
                    tax:                    null,
                    line_item_amount:       null,
                    line_item_tax_amount:   null
                });
                this.modals.lineItem.open = false;
            },

            openEditItems(item){
                // Check if the user has access to the line item contract
                let contract = item.contract;
                let arrContact = this.optionsContract.filter(item => item.id == contract.id);
                if(!arrContact.length) contract = null

                this.infoLineItem = Object.assign(this.infoLineItem,{
                    id:                     item.id,
                    contract:               item.contract,
                    contract_id:            contract ? item.contract_id : null,
                    property:               item.property,
                    dept_code:              item.dept_code,
                    document_line_no:       item.document_line_no,
                    gofix_document_ref_no:  item.gofix_document_ref_no,
                    gofix_document_ref_line_no: item.gofix_document_ref_line_no,
                    item_code:              item.item_code,
                    line_item_description:  item.line_item_description,
                    line_item_remark:       item.line_item_remark,
                    line_item_gl_code:      item.line_item_gl_code,
                    line_item_tax_code:     item.line_item_tax_code,
                    tax:                    item.tax,
                    line_item_amount:       item.line_item_amount,//this.$accounting.formatMoney(item.line_item_amount),
                    line_item_tax_amount:   item.line_item_tax_amount//this.$accounting.formatMoney(item.line_item_tax_amount)
                });
                this.modals.lineItem.title = "Edit Line Item"
                this.modals.lineItem.open = true;
            },

            saveLineItems(){
                if(!this.infoLineItem.line_item_gl_code) {
                    return this.$alertNotification("GL code is required", "danger");
                }
                let request = {
                    header_id: this.$route.params.id ? this.$route.params.id : null,
                    contract_agreement_ref: this.infoLineItem.contract ? this.infoLineItem.contract.id : null,
                    contract_id:            this.infoLineItem.contract ? this.infoLineItem.contract.id : null,
                    property_id:            this.infoLineItem.property ? this.infoLineItem.property.id : null,
                    dim_1:                  this.infoLineItem.dept_code ? this.infoLineItem.dept_code.dept_code : null,
                    document_line_no:       this.infoLineItem.document_line_no,
                    gofix_document_ref_no:  this.infoLineItem.gofix_document_ref_no,
                    gofix_document_ref_line_no: this.infoLineItem.gofix_document_ref_line_no,
                    item_code:              this.infoLineItem.item_code,
                    line_item_description:  this.infoLineItem.line_item_description,
                    line_item_remark:       this.infoLineItem.line_item_remark,
                    line_item_gl_code:      this.infoLineItem.line_item_gl_code,
                    line_item_tax_code:     this.infoLineItem.tax ? this.infoLineItem.tax.tax_code : null,
                    line_item_amount:       this.$accounting.unformat(this.infoLineItem.line_item_amount),
                    line_item_tax_amount:   this.$accounting.unformat(this.infoLineItem.line_item_tax_amount)
                }

                let method    = 'createGLLineItems';
                let keyMessage= 'adding'
                if(this.infoLineItem.id) {
                    request.id = this.infoLineItem.id
                    method     = 'updateGLLineItems';
                    keyMessage = 'editing'
                }

                this.$store.dispatch(`GeneralLedgerController/${method}`,request)
                    .then(reponse => {
                        this.$alertNotification(this.$notificationV2(keyMessage, 'line_item'));
                        this.getGeneralLedgerInfo();
                        this.$refs.gofixTable.reloadTableItems();
                        this.closeModal();
                    })
                    .catch(err => {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    })
            },

            cancelMiscExpense(){
                let request = {
                    activity_action : "Cancel",
                    status: "Cancelled",
                    id: this.$route.params.id
                };
                this.$store.dispatch(`MiscExpensesController/updateItem`, request)
                .then(result => {
                    this.$refs.itemActivities.triggerReloadData();
                    this.infoObj.status = result.data.data.status;
                    this.miscExpenseItem.status = result.data.data.status;
                    this.$alertNotification(this.$notificationV2('editing', 'gl_manual'));
                })
                .catch(err => {
                    console.log(err);
                })
            },

            /*Contract*/
            getContract(filter = null, limit = 100) {
                this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filter, limit])
                .then(response => {
                    this.optionsContract = response.data;
                })
            },

            searchContract(search, loading){
                this.optionsContract = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.getContract({contract_name: search });
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
    
            /*Property*/
            loadRootProperty(){
                this.loading.properties = true;
                global.axios(`api/contracts/${this.infoLineItem.contract.id}/tree-properties/0`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(result => {
                    this.treeProperty = result.data.data ? result.data.data : [];
                    this.loading.properties = false;
                })
                .catch(err => {
                    this.treeProperty = [];
                    this.loading.properties = false;
                })
            },

            /*Department code*/
            async getDepartmentCode(filter = {}, limit = 100) {
                filter.client_contract_id = this.infoLineItem.contract ? this.infoLineItem.contract.id : null
                filter.property_id = this.infoLineItem.property ? this.infoLineItem.property.id : null
                filter.is_dept_code = 1
                await this.$store.dispatch("PropertyDepartmentController/getItems", { limit: limit, page: 1, filter: filter })
                .then(response => {
                    this.optionsDepartment.options = response.items;
                })
            },

            searchDepartmentCode(search, loading) {
                loading(true);
                this.optionsDepartment.options = [];
                if (this.optionsDepartment.timer) {
                    clearTimeout(this.optionsDepartment.timer);
                    this.optionsDepartment.timer = null;
                }
                this.optionsDepartment.timer = setTimeout(async () => {
                    try {
                        await this.getDepartmentCode({dept_code: search});
                        await loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },

            /*FM code*/
            loadCOA(){
                this.$store.dispatch("FmCodeController/getCOA",{
                    limit: 100,
                    page: 1,
                    filter:{
                        coa_company_id: this.infoLineItem.contract && this.infoLineItem.contract.finance_company && this.infoLineItem.contract.finance_company.finance_company_id ? this.infoLineItem.contract.finance_company.finance_company_id : -1
                    }
                })
                    .then( response => {
                        this.optionsGLCode.options = response.items;
                    })
                    .catch( err => {
                        console.log(err);
                    });
            },

            searchCOA(search, loading){
                loading(true);
                this.optionsGLCode.options = [];
                if(this.optionsGLCode.timer) {
                    clearTimeout(this.optionsGLCode.timer);
                    this.optionsGLCode.timer = null;
                }

                this.optionsGLCode.timer = setTimeout(() => {
                    this.$store.dispatch( 'FmCodeController/getCOA', {
                        limit: 100,
                        filter: {
                            search: search,
                            coa_company_id: this.infoLineItem.contract && this.infoLineItem.contract.finance_company && this.infoLineItem.contract.finance_company.finance_company_id ? this.infoLineItem.contract.finance_company.finance_company_id : -1
                        }
                    })
                        .then(response => {
                            this.optionsGLCode.options = response.items;
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },

            getPayment(){
                let filter = {reference_type: "Payment Method"}
                let params = {filter: filter, limit: 100, isCMS: true }
                this.$store.dispatch(`MiscExpensesController/getReferences`, params)
                .then(response => {
                    this.optionsPayment = response.data.data.items;
                })
            },

            getFinanceCompanies(){
                this.$store.dispatch("ChartOfAccountController/getCompanies", {
                    limit: -1,
                    page: 1
                })
                    .then(response => {
                        this.optionsCompanies = response.items;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },

            /*Transaction Code*/
            getTransactionCode(){
                let params = {limit: 100, isCMS: false }
                this.$store.dispatch(`PostingEntryController/getPostingEntryItems`, params)
                .then(response => {
                    this.optionsTransaction = response.items;
                })
            },

            loadTax(filter = {}, limit = 100) {
                let request = {
                    isActive: 1,
                    isNotSave: 1,
                    limit: limit,
                    filter: filter
                }
                this.$store.dispatch("TaxVersioningController/getTaxItems", request).then(data => {
                  this.optionsTax = data.items;
                });
            },

            searchTaxCode(search, loading) {
                this.taxOptions = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.loadTax({tax_code: search}, 100);
                        loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            }
        }
    }
</script>
